import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";
import { AuthShell } from "./ManagerLogin";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      toast.error("Passwords do not match");
      return;
    }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated — sign in with your new password");
      navigate("/login");
    } catch (err) {
      toast.error(formatApiError(err, "Could not reset password"));
    } finally {
      setBusy(false);
    }
  };

  if (!token) {
    return (
      <AuthShell title="Invalid Link" subtitle="This reset link is missing its token">
        <Link to="/forgot-password" className="text-terra-600 hover:underline text-sm" data-testid="reset-request-new-link">
          Request a new reset link
        </Link>
      </AuthShell>
    );
  }

  return (
    <AuthShell title="Choose a New Password" subtitle="Minimum 6 characters">
      <form onSubmit={submit} className="space-y-4" data-testid="reset-password-form">
        <input
          type="password"
          required
          minLength={6}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="New password"
          data-testid="reset-password-input"
          className="w-full h-12 px-4 rounded-xl bg-[#FAF6F0] border border-[#E4DDD3] text-[#1A1D20] placeholder-slate-400 focus:outline-none focus:border-terra-400/60"
        />
        <input
          type="password"
          required
          minLength={6}
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
          placeholder="Confirm new password"
          data-testid="reset-password-confirm-input"
          className="w-full h-12 px-4 rounded-xl bg-[#FAF6F0] border border-[#E4DDD3] text-[#1A1D20] placeholder-slate-400 focus:outline-none focus:border-terra-400/60"
        />
        <button
          type="submit"
          disabled={busy}
          data-testid="reset-password-submit-button"
          className="w-full h-12 rounded-xl bg-terra-500 text-white font-display font-bold text-lg hover:bg-terra-600 disabled:opacity-50 transition-colors"
        >
          {busy ? "Updating…" : "Update Password"}
        </button>
      </form>
    </AuthShell>
  );
}
